ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
_ = require 'underscore'
l = require 'lib/localize'
Auth = require 'db/auth'
getExperiment = require 'lib/experiments/simple-test'

module.exports =
  routes: [['*splat', 'displayErrorPage']]

  displayErrorPage: (opts) ->
    ModelLoader.await('headerData')
    .then =>
      if Auth.me() && Auth.isLoggedIn() && !Auth.confirmed() &&
          getExperiment('confirmDuringSignup').get('enabled')
        return @navigate '/confirm-email', { trigger: true }

    data = _.extend { errorType: 'notFound' }, opts,
      url: location.pathname + location.search
      isLoggedIn: Auth.isLoggedIn()

    @errorView { title: l('error'), data }



// WEBPACK FOOTER //
// ./app/scripts/controller/catchall-route.coffee